import axios from 'axios'
import baseInfo from './baseUrl'
import clientId from './client'
import { Loading, Message } from 'element-ui'
import CryptoJS from '../assets/js/aes';
import qs from 'qs';

const http = {};
const current_system = 'b_onlinesigning'
    //JS加密
function convertDate(date) {
    let res = date.getFullYear() + ',' + (date.getMonth() + 1) + ',' + date.getDate() + ',' + date.getHours() + ',' + date.getMinutes() + ',' + date.getSeconds();
    return res;
}

function encryp(clientId) {
    let data = clientId + '--' + convertDate(new Date());
    let key = CryptoJS.enc.Utf8.parse('607490BE-18CA-43D7-B11A-57E2621B');
    let iv = CryptoJS.enc.Utf8.parse('2D59831C-78AC-4227-B3F3-CE656636');

    let encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}
var instance = axios.create({
    timeout: 500000,
    baseURL: baseInfo.baseUrl
})

var instanceAgent = axios.create({
        timeout: 5000,
        baseURL: baseInfo.agentUrl
    })
    // 添加请求拦截器
instance.interceptors.request.use(
    function(config) {
        // console.log(1,config)
        // 请求头添加token
        if (localStorage.getItem('tokenInfo')) {
            let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'))
            config.headers.access_token = tokenInfo.access_token
        }
        if (localStorage.getItem('accountid')) {
            config.headers.accountid = JSON.parse(localStorage.getItem('accountid'))
        }
        if(config.url == '/account_user/department'){
            delete config.headers.accountid
            console.log(config.headers)
        }
        config.headers.client_id = clientId
        config.headers.current_system = current_system

        return config
    },
    function(error) {
        console.log('error', error)
        return Promise.reject(error)
    }
)

instanceAgent.interceptors.request.use(
    function(config) {
        // 请求头添加token
        // if (store.state.UserToken) {
        //     config.headers.token = localStorage.getItem('token')
        // }
        config.headers.client_id = encryp(clientId)
        return config
    },
    function(error) {
        return Promise.reject(error)
    }
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        if (!(err && err.response)) {
            err.message = '连接服务器失败'
        }
        // Message.error({
        //     message: err.message
        // })
        return Promise.reject(err.response)
    }

)

instanceAgent.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        if (!(err && err.response)) {
            err.message = '连接服务器失败'
        }
        // Message.error({
        //     message: err.message
        // })
        return Promise.reject(err.response)
    }

)

http.get = function(url, options) {
    // console.log(url, options)
    let loadingInstance = Loading.service({ fullscreen: true });
    return new Promise((resolve, reject) => {
        instance
            .get(url, options)
            .then(response => {
                if (response) {
                    resolve(response)
                } else {
                    response = { code: 1 }
                    resolve(response)
                }
                loadingInstance.close()
            })
            .catch(e => {
                console.log('get_err', e);
                loadingInstance.close()
                if (e && e.data) {
                    if (e.data.Errcode === '1016') {
                        localStorage.removeItem('tokenInfo')
                        window.location.reload()
                    }
                    if (e.data.Errcode !== '1021') {
                        Message.error({
                            message: e.data.Errmsg
                        })
                    }
                    if (e.data.Errcode === '1006'|| e.data.Errcode === '1021') {
                        localStorage.removeItem('tokenInfo')
                        window.location.reload()
                    }
                }
            })
    })
}

http.post = function(url, data, options) {
    let loadingInstance = Loading.service({ fullscreen: true });
    return new Promise((resolve, reject) => {
        instance
            .post(url, data, options)
            .then(response => {
                loadingInstance.close()
                if (response) {
                    resolve(response)
                } else {
                    response = { code: 1 }
                    resolve(response)
                }
            })
            .catch(e => {
                console.log('post_err', e);
                reject(e)
                Message.error({
                    message: e.data.Errmsg
                })
                loadingInstance.close()
                if (e && e.data) {
                    if (e.data.Errcode === '1006' || e.data.Errcode === '1021') {
                        localStorage.removeItem('tokenInfo')
                        window.location.reload()
                    }
                }
            })
    })
}
http.downloadZip = function(url, data, options) {
    console.log('options', options)
    let loadingInstance = Loading.service({ fullscreen: true });
    return new Promise((resolve, reject) => {
        instance
            .get(url, options)
            .then(response => {
                if (response) {
                    resolve(response)
                } else {
                    response = { code: 1 }
                    resolve(response)
                }
                loadingInstance.close()
            })
            .catch(e => {
                if (e && e.data) {
                    Message.error({
                        message: e.data.Errmsg
                    })
                }
                loadingInstance.close()
            })
    })
}

http.agentPost = function(url, data, options) {
    let loadingInstance = Loading.service({ fullscreen: true });
    return new Promise((resolve, reject) => {
        // qs.stringify(data)
        instanceAgent
            .post(url, data, options)
            .then(response => {
                loadingInstance.close()
                if (response) {
                    resolve(response)
                } else {
                    response = { code: 1 }
                    resolve(response)
                }
            })
            .catch(e => {
                loadingInstance.close()
                if (e && e.data) {
                    Message.error({
                        message: e.data.Errmsg
                    })
                    if (e.data.Errcode === '1006' || e.data.Errcode === '1021') {
                        localStorage.removeItem('tokenInfo')
                        window.location.reload()
                    }
                }
            })
    })
}

export default http